<template>
  <div class="TheNavbarMenuDropdown">
    <div class="TheNavbarMenuDropdown__links">
      <ul class="TheNavbarMenuDropdown__links-list">
        <li
          v-for="link in links"
          :key="link.label"
          class="TheNavbarMenuDropdown__links-item"
        >
          <RouterLink
            v-if="link.link"
            :to="link.link"
            @click="$emit('close')"
            class="TheNavbarMenuDropdown__links-item-link"
          >
            <UIIcon
              v-if="link.icon"
              :name="link.icon"
              class="TheNavbarMenuDropdown__links-item-icon"
            />
            <div class="TheNavbarMenuDropdown__links-item-content">
              <div class="TheNavbarMenuDropdown__links-item-label">
                {{ link.label }}
              </div>
              <div class="TheNavbarMenuDropdown__links-item-description">
                {{ link.description }}
              </div>
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>

    <TheNavbarJoinCommunity
      class="TheNavbarMenuDropdown__promo"
      @click="$emit('close')"
    />
  </div>
</template>

<script setup lang="ts">
import UIIcon from '../../../icons/UIIcon.vue'
import { INavbarItem } from '../TheNavbar.vue'
import TheNavbarJoinCommunity from './TheNavbarJoinCommunity.vue'

defineEmits(['close'])
defineProps<{
  links: INavbarItem[]
}>()
</script>

<style lang="scss">
.TheNavbarMenuDropdown {
  background-color: $color-white;
  border: 1px solid #00000014;
  border-radius: 16px;
  display: grid;
  // grid-template-columns: 21rem 19rem;
  grid-template-columns: 1fr;

  @include md {
    grid-template-columns: 320px 288px;
  }

  .TheNavbarMenuDropdown__links {
    padding: 0.5rem;
    max-width: 20rem;
  }

  .TheNavbarMenuDropdown__links-item {
    .TheNavbarMenuDropdown__links-item-link {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;
      padding: 0.75rem;
      border-radius: 8px;
      cursor: pointer;
      text-decoration: none;
      color: inherit;

      &:hover {
        background-color: $color-ui-gray-cool-50;
      }
    }
  }

  .TheNavbarMenuDropdown__links-item-icon {
    --size: 1.25rem;
    --color: #{$color-ui-accent-main};
  }

  .TheNavbarMenuDropdown__links-item-label {
    @include font-size-16px;
    font-weight: 600;
    color: $color-ui-gray-cool-900;
  }

  .TheNavbarMenuDropdown__links-item-description {
    @include font-size-14px;
    margin-top: 0.125rem;
    color: $color-ui-gray-cool-600;
  }

  .TheNavbarMenuDropdown__promo {
    padding: 1.25rem;
    background-color: $color-ui-gray-cool-50;
  }
}
</style>
